import { Icon, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

interface SuccessMessageProps {}

export const SuccessMessage: React.FC<SuccessMessageProps> = () => {
  return (
    <Box
      p={Spacing['inline.nano']}
      borderRadius={BoxRadius.sm}
      bg={Utils.ColorToken.WithOpacity('neutral.lightest', 0.2)}>
      <HStack space={Spacing['inline.nano']}>
        <Icon testID="qa" name="Check" size="md" color={Color['feedback.success.default']} />
        <VStack space={Spacing['inline.quarck']} flex={1}>
          <Text fontSize={Typography['fontsize.lg']} variant="semibold" color="neutral.black">
            Recomendação de consórcio enviada com sucesso .
          </Text>
          <Text fontSize={Typography['fontsize.lg']} variant="regular" color="neutral.black">
            Você poderá acompanhar suas ordens clicando no botão{' '}
            <Text fontWeight="semibold">acompanhar.</Text>
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};
